import { createApp } from "vue";
import i18n from '@/i18n'
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

import '@fancyapps/fancybox';

// 将 jQuery 挂载到全局
window.$ = $;
window.jQuery = $;

window.result.exchangeToken='21344'


import '@/assets/js/calculator-src'
import '@/assets/tailwind.css'
import '@/styles/0-base/custom.scss'
import "@/styles/1-plugins/base/_typography.scss"
import '@/styles/2-layouts/navbar03.scss'
import '@/styles/2-layouts/segmented-search.scss'
import _ from 'lodash'

import 'bootstrap/dist/js/bootstrap.min.js'
import 'owl.carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'slick-carousel/slick/slick.min.js'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import '@/styles/2-layouts/upstox-homepage-simplified.scss'
import '@/styles/2-layouts/upstox-homepage-responsive.scss'
import '@/styles/2-layouts/ratan-tata.scss'
import '@/styles/2-layouts/footer.scss'
import '@/styles/2-layouts/new-footer.scss'

const app = createApp(App)
app.config.globalProperties.lodash = _;
app.config.globalProperties.$fancybox = $; // 将 $ 挂载到全局
window.lodash = _.noConflict();
app.use(store).use(router).use(i18n).mount("#app");
